import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import MotiveTitle from '../../../Contact/Motive/MotiveTitle';
import ProductPreview from '../../../../common/ProductPreview';
import AppInput from '../../../../common/AppInput';
import UploadFiles from '../../../../common/UploadFiles';
import { COMPLETE_FORM } from '../../../../../constants/texts';
import { useBadStateStyles } from './styles';
import { textMapper } from '../../../../../helpers/FormHelper';
import DeadlineExpiredWithNoReverse from '../../../Issues/DeadlineExpiredWithNoReverse';
import { useSelector } from 'react-redux';
import Loader from '../../../../common/Loader';

const Form = ({ ...props }) => {
  const { state, onData, fields, mobile, motiveId, setShowForm } = props;
  const classes = useBadStateStyles({ mobile });

  const { messages, status, innerMessage, getStatus } = useSelector(
    (state) => state.validationProductSlice,
  );

  let loadingGif = getStatus === 'loading';

  const handleChange = (e) => {
    onData({ name: e.target.name, value: e.target.value });
  };

  useEffect(() => {
    setShowForm(status);
  }, [status]);

  const setCollectionFiles = async (files, fileRejections) => {
    if (fileRejections.length === 0) {
      if (files !== undefined) {
        files.forEach((file, index) => {
          const imgName = `image${index + 1}`;
          Object.assign(state, { [imgName]: file });
        });
      }
    }
  };

  useEffect(() => {
    if (loadingGif) setShowForm(false);
    else setShowForm(status);
  }, [loadingGif]);

  return (
    <React.Fragment>
      <MotiveTitle
        title={textMapper.get(motiveId).title}
        subtitle={textMapper.get(motiveId).subtitle}
        icon={textMapper.get(motiveId).icon}
        mobile={mobile}
      />

      <ProductPreview mobile={mobile} />

      {loadingGif && <Loader mobile={mobile} />}

      {!status &&
        messages &&
        innerMessage.includes('Product with credit note') && (
          <DeadlineExpiredWithNoReverse
            issueForm
            mobile={mobile}
            motiveId="8"
            typeId="2"
          />
        )}

      {status && (
        <Typography className={classes.title}>{COMPLETE_FORM}</Typography>
      )}

      {status &&
        fields.map((field, index) => (
          <React.Fragment key={index}>
            {!field.hidden && (
              <AppInput
                onChange={handleChange}
                onBlur={() => {}}
                onClick={() => {}}
                disabled={state[field.name]?.disabled || false}
                name={field.name}
                error={state[field.name]?.error || false}
                type={state[field.name]?.type || ''}
                label={state[field.name]?.label || ''}
                required={state[field.name]?.required || false}
                inputAdornment={state[field.name]?.inputAdornment || ''}
                success={state[field.name]?.success || ''}
                helperText={state[field.name]?.helper || ''}
                multiline={state[field.name]?.multiline || false}
                rows={state[field.name]?.rows || ''}
                value={state[field.name]?.value || ''}
                errorMessage={state[field.name]?.message || ''}
              />
            )}
          </React.Fragment>
        ))}

      {status && (
        <UploadFiles
          mobile={mobile}
          onFileUpload={setCollectionFiles}
          issueFormName="BadState"
        />
      )}
    </React.Fragment>
  );
};

Form.propTypes = {
  state: PropTypes.object,
  onData: PropTypes.func,
  fields: PropTypes.array,
  mobile: PropTypes.bool,
  motiveId: PropTypes.string,
  setShowForm: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
};

export default Form;
